import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";
interface IinitialState {
  user: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    postCode: string;
    street: string;
    address: string;
    town: string;
    buildingNumber: string;
    country: string;
    password: string;
    newPassword: string;
    confirmPassword: string;
    imageId: string;
    pcnNotifications: any;
    appealNotifications: any;
    parkingNotifications: any;
    marketingPreferences: any;
    consultationFee: any;
    employee: any;
  };
}
const initialState: IinitialState = {
  user: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    consultationFee: "",
    postCode: "",
    street: "",
    address: "",
    town: "",
    buildingNumber: "",
    country: "",
    password: "",
    newPassword: "",
    confirmPassword: "",
    imageId: "",
    pcnNotifications: {},
    appealNotifications: {},
    parkingNotifications: {},
    marketingPreferences: {},
    employee: {},
  },
};
export const getProfileData = createAsyncThunk<IinitialState>("getProfileData/setProfileData", async (_, thunkAPI) => {
  try {
    const response = await ApiClient.get("users/profile");
    if (response?.data?.user?.roles?.includes("Employee")) {
      const getEmployee = await ApiClient.get("employee-management");
      return { user: { ...response?.data?.user, employee: getEmployee?.data?.employees?.data[0] } };
    }
    return response.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error);
  }
});
const userProfileSlice = createSlice({
  name: "getProfileData",
  initialState,
  reducers: {
    setProfileData(state, action) {
      state.user = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProfileData.fulfilled, (state, action: PayloadAction<IinitialState>) => {
      state.user = action.payload.user;
      state.user.imageId = process.env.REACT_APP_AWS_BASE_URL + action.payload.user.imageId;
    });
  },
});
export const { setProfileData } = userProfileSlice.actions;
export default userProfileSlice;
